export default "__VITE_ASSET__BvtgEZHx__"